import React from 'react';
import { ChevronDown, ChevronUp } from 'lucide-react';
import type { NetworkType } from '@mls-wallet/shared-types';
import { getNetworkNativeTokenSymbol } from '@mls-wallet/shared-types';

interface ContractTxDetailsHeaderProps {
  functionName: string;
  contractAddress: string;
  nativeTokenValue?: { value: string; decimals: number } | undefined;
  networkId: NetworkType;
  expanded: boolean;
}

/**
 * Header summary for a contract call (function + address + optional value).
 */
export function ContractTxDetailsHeader({
  functionName,
  contractAddress,
  nativeTokenValue,
  networkId,
  expanded,
}: ContractTxDetailsHeaderProps): React.ReactElement {
  return (
    <div className="flex items-center justify-between gap-2 w-full">
      {/* Left side: Function name, address, and native token - wraps if needed */}
      <div className="flex flex-wrap items-baseline gap-2 min-w-0 flex-1">
        <span className="font-semibold text-[16px] text-zinc-900 shrink-0">
          {functionName}
        </span>
        <span className="font-mono text-[12px] text-zinc-600 break-words">
          {contractAddress}
        </span>
        {nativeTokenValue &&
          Number.isFinite(Number(nativeTokenValue.value)) &&
          Number(nativeTokenValue.value) > 0 && (
            <span className="text-[12px] text-zinc-600 shrink-0">
              Send{' '}
              <span className="font-semibold">
                {nativeTokenValue.value}{' '}
                {getNetworkNativeTokenSymbol(networkId)}
              </span>
            </span>
          )}
      </div>
      {/* Right side: Chevron - always stays on right */}
      {expanded ? (
        <ChevronUp className="w-5 h-5 text-zinc-500 flex-shrink-0" />
      ) : (
        <ChevronDown className="w-5 h-5 text-zinc-500 flex-shrink-0" />
      )}
    </div>
  );
}
